import React from 'react';
import { useTranslation } from 'react-i18next';
import { Play } from 'lucide-react';

const CTA = () => {
  const { t } = useTranslation();

  return (
    <section id="start" className="py-20 md:py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-red-500/5 to-transparent" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-red-500/10 rounded-full blur-[150px]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Content */}
        <div className="gradient-border rounded-3xl p-1">
          <div className="bg-gradient-to-br from-white/5 to-transparent rounded-3xl p-8 md:p-16">
            <h2 className="font-display text-3xl md:text-5xl font-bold mb-6">
              <span className="gaming-gradient-text">{t('cta.title')}</span>
            </h2>
            <p className="text-lg text-white/60 max-w-2xl mx-auto mb-10">
              {t('cta.subtitle')}
            </p>
            <a 
              href="/s"
              className="inline-flex glow-button px-10 py-4 rounded-xl font-semibold text-white items-center gap-3 text-lg animate-pulse-glow"
            >
              <Play className="w-6 h-6" fill="currentColor" />
              {t('cta.button')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
